import React from "react";
import { Navigate, BrowserRouter as Router } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import MainLayout from "./Components/Layout/MainLayout";
import InvitationTypes from "./Components/Pages/MyInvitations/Invitation-Type/InvitationTypes";
import Themes from "./Components/Pages/MyInvitations/Themes/Themes";
import WeddingForm from "./Components/Pages/MyInvitations/Wedding/Form";
import DemoForm from "./Components/Pages/MyDemos/Demo/Form";
import Login from "./Components/Pages/Login/LogIn";
import SsoLogin from "./Components/Pages/SsoLogin/SsoLogin";
import ForgotPassword from "./Components/Pages/ForgotPassword/ForgotPassword";
import VerifyOtp from "./Components/Pages/ForgotPassword/VerifyOtp";
import ResetPassword from "./Components/Pages/ForgotPassword/ResetPassword";
import Myaccounts from "./Components/Pages/Profiles/Myaccounts";
import StudiosList from "./Components/Pages/Studio/StudiosList";
import EditStudio from "./Components/Pages/Studio/EditStudio";
import Dashboard from "./Components/Pages/Dashboard/Dashboard";
import EditUser from "./Components/Pages/Profiles/EditUser";
import PackagesCart from "./Components/Pages/Payments/PackagesCart";
import Registration from "./Components/Pages/Registration/Registration";
import { useAuth } from "./Components/Context/store/context";
import Loader from "./Components/Pages/Loader/Loader";
import { ToastContainer, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyInvitations from "./Components/Pages/MyInvitations/MyInvitations";
import MyPlan from "./Components/Pages/MyPlan/MyPlan";
import MyDemos from "./Components/Pages/MyDemos/MyDemos";
import MyServices from "./Components/Pages/Services/MyServices";
import AddSerices from "./Components/Pages/Services/AddSerices";
import WebsiteForm from "./Components/Pages/MyWebsite/CreateWebsite/WebsiteForm";
import Downloads from "./Components/Pages/Downloads/Downloads";
import MyDomains from "./Components/Pages/Domains/MyDomains";
import MyOneQr from "./Components/Pages/MyQrCode/MyOneQr";
import BirthdayForm from "./Components/Pages/MyInvitations/Birthday/Form";
import Addons from "./Components/Pages/Addons/Addons";

// handling loader
const LoaderWrapper = ({ children }) => {
  const { loading } = useAuth();

  return (
    <>
      {loading && <Loader />}
      {children}
    </>
  );
};

// main app
function App() {
  return (
    <>
      <LoaderWrapper>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/sso-login" element={<SsoLogin />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/verify" element={<VerifyOtp />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<Registration />} />
            <Route path="/" element={<MainLayout />}>
              <Route path="" element={<Navigate to="/dashboard" replace />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="invitations" element={<MyInvitations />} />
              <Route path="create-invitation" element={<InvitationTypes />} />
              <Route path="create-invitation/themes/:id" element={<Themes key="create-invitation" />} />
              <Route path="change-theme/:eventId/:id" element={<Themes key="change-theme" />} />
              <Route path="create-invitation/wedding/:categoryId/:themeId" element={<WeddingForm />} />
              <Route path="create-invitation/birthday/:categoryId/:themeId" element={<BirthdayForm />} />
              <Route path="invitations/wedding/:id" element={<WeddingForm />} />
              <Route path="invitations/birthday/:id" element={<BirthdayForm />} />
              <Route path="profile" element={<Myaccounts />} />
              <Route path="/profile/edit" element={<EditUser />} />
              <Route path="mystudios" element={<StudiosList />} />
              <Route path="mystudios/add" element={<EditStudio />} />
              <Route path="mystudios/edit/:id" element={<EditStudio />} />
              <Route path="plans" element={<MyPlan />} />
              <Route path="services" element={<MyServices />} />
              <Route path="services/add" element={<AddSerices />} />
              <Route path="services/edit/:id" element={<AddSerices />} />
              <Route path="demos" element={<MyDemos />} />
              <Route path="create-demo" element={<Themes key="create-demo" />} />
              <Route path="create-demo/themes" element={<Themes key="create-demo-themes" />} />
              <Route path="create-demo/:themeId" element={<DemoForm key="create-demo" />} />
              <Route path="demos/:id" element={<DemoForm key="demos" />} />
              <Route path="create-website" element={<Themes key="create-website" />} />
              <Route path="create-website/:themeId" element={<WebsiteForm key="create-website-form" />} />
              <Route path="website/:id" element={<WebsiteForm key="website-edit-form" />} />
              <Route path="change-website-theme/:profileId/:id" element={<Themes key="create-website-theme" />} />
              <Route path="downloads" element={<Downloads />} />
              <Route path="domains" element={<MyDomains />} />
              <Route path="myqrcode" element={<MyOneQr />} />
              <Route path="addons" element={<Addons />} />
            </Route>
            <Route path="/packagescart" element={<PackagesCart />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="/*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </LoaderWrapper>
      <div>
        <ToastContainer
          position="top-center"
          autoClose={5000}
          newestOnTop
          closeOnClick
          rtl={false}
          draggable={false}
          pauseOnFocusLoss={false}
          pauseOnHover
          theme="dark"
          transition={Slide} />
      </div>
    </>
  );
}
export default App;
